import type { Dictionary } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type { GroupType } from '@chancenwerk/enums/enums.js';

@Entity()
export class CampusUserGroupFilter extends AdornisFilter {
  static override _class = 'CampusStudentGroupFilter';

  @Field(() => Int)
  public type?: GroupType;

  @Field(() => String)
  public kuerzel?: string;

  override getMongoFilter() {
    const obj = this.toObject();
    const selector: Dictionary<any> = {};
    if (obj.search) {
      selector.$or = [{ name: { $regex: this._safeRegex(obj.search), $options: 'i' } }];
    }
    if (obj.type !== undefined) {
      selector.groupType = obj.type;
    }
    return selector;
  }
}
